<template>
    <div class="main-content">
        <div class="learning-content">
            <div class="container">
                <div class="row">
                    <div class="col-12">
                        <div class="heading text-center">
                            <h1>Discover <span>Enterprise DNA Training Programs</span></h1>
                            <p>Empowering the most valuable Power BI users to expand their analytical thinking and insight generation possibilities</p>
                        </div>
                    </div>
                </div>
                <div class="row">
                    <div class="col-12 col-sm-6 mb-4">
                        <div class="learning-card">
                            <div class="learning-card-img">
                                <img src="/assets/img/learning-card-img1.png" alt="" width="157">
                            </div>
                            <h2>For Individuals</h2>
                            <p>Would you like to improve your Power BI knowledge and skills? Upgrade your Enterprise DNA membership now.</p>
                            <a href="https://enterprisedna.co/membership" target="_blank" class="btn btn-outline-primary">Become A Member</a>
                        </div>
                    </div>
                    <div class="col-12 col-sm-6 mb-4">
                        <div class="learning-card">
                            <div class="learning-card-img">
                                <img src="/assets/img/learning-card-img2.png" alt="" width="157">
                            </div>
                            <h2>For Teams</h2>
                            <p>Are you a company who wants to upgrade your employees Power BI skills? Check out the Enterprise DNA Center of Excellence (CoE).</p>
                            <a href="https://enterprisedna.co/center-of-excellence/" target="_blank" class="btn btn-outline-primary">Discover Our COE</a>
                        </div>
                    </div>
                </div>
                <div class="row">
                    <div class="col-12">
                        <div class="already-training-text text-center">
                            <p>Already an Enterprise DNA Training Member?</p>
                            <a href="https://sso.teachable.com/secure/78853/users/sign_in" target="_blank" class="btn btn-primary">LOGIN HERE</a>
                        </div>
                    </div>
                </div>
            </div>
        </div>
    </div>
</template>

<script>
export default {
    name: "Learn",
    mounted() {
        const titleEl = document.querySelector('head title');
        titleEl.textContent = 'Analyst Hub by Enterprise DNA';
    }
}
</script>

<style scoped>
</style>
